import React, { useCallback, useState } from "react";
import * as Scrivito from "scrivito";
import cx from "classnames";
import { Icon } from "components";

import { useTranslate } from "hooks";
import s from "../ProductConfiguratorLeftSidebar.module.scss";

export const ProductConfiguratorLeftSidebarItem = Scrivito.connect(
  ({
    headline,
    elementState,
    parts = [],
    activePart,
    setActivePart,
    activatePartItem,
    pageState,
    setPageState,
  }) => {
    const translate = useTranslate();
    const [showParts, setShowParts] = useState(true);
    const hasParts = parts.length > 0;

    const activateProductsNavigationItem = useCallback(() => {
      window.scrollTo(0, 0);
      if (hasParts) {
        setShowParts(pageState === elementState ? !showParts : true);
      }

      setPageState(elementState);
      setActivePart(null);
    }, [
      elementState,
      hasParts,
      pageState,
      setActivePart,
      setPageState,
      showParts,
    ]);

    return (
      <div>
        <button
          onClick={activateProductsNavigationItem}
          className={cx(
            "w-100 border-0 position-relative d-flex justify-content-between align-items-center m-0 fs-18 p-3_5 text-nowrap cursor-pointer text-truncate",
            s.productsNavigationItem,
            s.backgroundTest,
            {
              [s.productsNavigationItemActive]: pageState === elementState,
            },
          )}
        >
          {translate(headline)}
          {hasParts && (
            <Icon
              iconName={`fa-regular fa-angle-${
                pageState === elementState && showParts ? "up" : "down"
              }`}
              className="icon-32"
            />
          )}
        </button>
        {pageState === elementState &&
          showParts &&
          parts
            .filter(
              (part) =>
                part.state !== 2 &&
                part.state !== 4 &&
                (part.state !== 3 || (part.state === 3 && part.presentation)),
            )
            .map((part, index) => (
              <div className="px-4" key={index}>
                <button
                  className={cx(
                    "d-flex w-100 justify-content-between px-2 py-3 cursor-pointer text-truncate fs-md",
                    s.part,
                    {
                      [s.partActive]: activePart === part.key,
                    },
                  )}
                  onClick={(e) => activatePartItem(part, e)}
                  title={part.title}
                >
                  {part.title}
                </button>
              </div>
            ))}
      </div>
    );
  },
);
